import Boiler from '@/models/Boiler'
import User, { hasRole, Role } from '@/models/User'

export default class BoilerPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, boiler: Boiler) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === boiler.entry.catalog.company.id
			case Role.AUDITOR:
				return boiler.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, boiler: Boiler) {
		return hasRole(user, Role.USER) && user.company?.id === boiler.entry.catalog.company.id
	}

	restore(user: User, boiler: Boiler) {
		return hasRole(user, Role.USER) && user.company?.id === boiler.entry.catalog.company.id
	}

	delete(user: User, boiler: Boiler) {
		return hasRole(user, Role.USER) && user.company?.id === boiler.entry.catalog.company.id
	}

	forceDelete(_user: User, _boiler: Boiler) {
		return false
	}
}
